import { Injectable } from '@angular/core';

import { TypedDialogService } from '@libs/src/typed-dialog/typed-dialog.service';

import { DialogConfirmPromptComponent } from './dialog-confirm-prompt.component';

import { DialogConfirmPromptData } from './dialog-confirm-prompt-data';

@Injectable({
  providedIn: 'root',
})
export class DialogConfirmPromptService {
  constructor(private readonly dialog: TypedDialogService) {}

  openDialog(data: DialogConfirmPromptData) {
    return this.dialog.open(DialogConfirmPromptComponent, {
      data,
      maxWidth: '500px',
      width: '95vw',
    });
  }
}
